import { Language, languages } from 'utils/types/common';

export const parseLangFromPath = (pathname: string): Language => {
  const pathParts = pathname.split('/');
  const langPart = pathParts.length > 1 && (pathParts[1] as Language);
  return langPart && languages.includes(langPart) ? langPart : 'fi';

  // TODO REMOVE IF NO PATHS
};

export const parseLangFromLocation = (location: Location): string => {
  const params = new URLSearchParams(location.search);
  const langParam = params.get('lang') as Language;
  return langParam && languages.includes(langParam) ? langParam : 'fi';
};
